/* eslint-disable react/jsx-max-props-per-line */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Menu, MenuItem } from '@mui/material';
import SortIcon from '@mui/icons-material/Sort';

/** Botão Ordenar no header do WidgetV2 (header escuro). */
const DigitacaoSortMenuButton = ({ sortMode, onChange, options }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  return (
    <>
      <Button
        size="small"
        variant="outlined"
        startIcon={<SortIcon />}
        onClick={(event) => setAnchorEl(event.currentTarget)}
        sx={{
          color: 'common.white',
          borderColor: 'rgba(255,255,255,0.4)',
          '&:hover': {
            borderColor: 'common.white',
            bgcolor: 'rgba(255,255,255,0.08)',
          },
        }}
      >
        Ordenar
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        {options.map((option) => (
          <MenuItem
            key={option.mode}
            selected={sortMode === option.mode}
            onClick={() => {
              onChange(option.mode);
              setAnchorEl(null);
            }}
          >
            {option.title}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

DigitacaoSortMenuButton.propTypes = {
  sortMode: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      mode: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default DigitacaoSortMenuButton;
